import { ThemeProvider } from '@emotion/react'
import { Box, Button, Container, IconButton } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import * as React from 'react'
import theme from '../theme'
import api from '../services/api'
import AddIcon from '@mui/icons-material/Add';
import FormDialog from './FormDialog'
import FormDialogTimes from './FormDialogTimes'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../auth/AuthProvider'
import { useNavigate } from 'react-router-dom'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
export default function () {
    const navigate = useNavigate()
    const auth = useAuth()
    const [handlerDialog, setHandlerDialog] = React.useState(false)
    const [handlerDialogTime, setHandlerDialogTime] = React.useState(false)
    const [update, setUpdate] = React.useState(false)
    const [id, setId] = React.useState()
    React.useEffect(() => {
        setUpdate(false)
        updateData()

    }, [handlerDialog, update])

    React.useEffect(()=>{
        document.title = "Horus - APIS"
      },[])
    const [data, setData] = React.useState()
    const columns = [
        {
            name: 'id',
            label: 'Id',
            options: {
                display: false
            }
        },
        {
            name: 'cod_empresa',
            label: "Empresa",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'url',
            label: "Endereço",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: 'username',
            label: "Usuário",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: 'active',
            label: "Estado",
            options: {
                customBodyRender: value => <span>{value ? "Ativo" : 'Inativo'}</span>,
                filter: false,
                sort: true,
            }
        },
        {
            name: "actions",
            label: "Ações",
            options: {
                customBodyRenderLite: (dataIndex, rowIndex) =>
                    <>
                        <Button  disabled={!auth.hasPerm('api_zabbix.edit')} sx={{ color: theme.palette.text.primary }} onClick={() => {
                           const id = data[dataIndex].id
                           setId(id)
                           setHandlerDialogTime(true)

                        }}>
                            <CalendarMonthIcon />
                        </Button>
                        <Button disabled={!auth.hasPerm('api_zabbix.edit')} sx={{ color: theme.palette.text.primary }} onClick={() => {
                            const id = data[dataIndex].id
                            setId(id)
                            setHandlerDialog(true)
                        }}>
                            <EditIcon />
                        </Button>
                        <Button  disabled={!auth.hasPerm('api_zabbix.delete')} sx={{ color: theme.palette.text.primary }} onClick={() => {
                            const id = data[dataIndex].id
                            const name = data[dataIndex].cod_empresa
                            deleteItem(id, name)

                        }}>
                            <DeleteIcon />
                        </Button>
                    </>

            }
        }
    ]
    const deleteItem = (id, name) => {
        const conf = confirm(`Deseja realmente apagar a ${name}`)
        if (!conf) return
        api.delete(`api_zabbix/delete/${id}/`).then(() => {
            setUpdate(true)
        }).catch(err => alert('Algum erro aconteceu...'))
    }
    const updateData = () => {
        api.get('api_zabbix/all')
            .then(res => setData(res.data))
            .catch((err) => {
                if(err.response.status==401){
                  navigate('/401')
                }
                setData()
              })
    }
    const showFormDialog = () => {
        setId()
        setHandlerDialog(true)
    }
    const options = {
        filterType: 'checkbox',
        rowsPerPageOptions: [30, 50, 100, 500],
        rowsPerPage: 30,
        rowHover: false,
        print: false,
        selectableRows: 'none',
        download: false,
        customToolbar: () => <IconButton disabled={!auth.hasPerm('api_zabbix.create')} onClick={showFormDialog} sx={{ color: theme.palette.text.primary }}><AddIcon /></IconButton>,
        customToolbarSelect: () => { },
    }
    return (
        <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
            <ThemeProvider theme={theme}>
                <FormDialog open={handlerDialog} id={id} handlerClose={() => setHandlerDialog(false)} updateData={updateData}/>
                <FormDialogTimes open={handlerDialogTime} id={id} data={data} handlerClose={() => setHandlerDialogTime(false)} updateData={updateData} />
                <Box sm={12} lg={12}>
                    <MUIDataTable
                        title={"Apis do Zabbix"}
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </Box>
            </ThemeProvider>
        </Container>
    )
}